import { BrowserRouter, Routes, Route } from "react-router";
import AppMenu from "./components/AppMenu";
import { ScannerProvider } from "./features/scanners/ScannerContext";
import ScannerInitializer from "./features/scanners/ScannerInitializer";
import PickList from "./features/pick-list";
import KwcBags from "./features/kwc-bags";
import KwcBins from "./features/kwc-bins";
import { KwcBagsTest } from "./features/kwc-bags/Test";
import { KwcBinsTest } from "./features/kwc-bins/Test";
import { AppProvider } from "./context/AppContext";
import QrCodeOverview from "./features/navigation/QrCodeOverview";
import NavigationScanListener from "./features/navigation/NavigationScanListener";
import CounterPickup from "./features/counter-pickup";
import Worktable from "./features/worktable";
import WorktableList from "./features/worktable/WorktableList";

function App() {
  return (
    <AppProvider>
      <ScannerProvider>
        <ScannerInitializer />
        <BrowserRouter>
          <NavigationScanListener />
          <Routes>
            <Route path="/" element={<AppMenu />} />
            <Route path="/kwc-bins">
              <Route index element={<KwcBins />} />
            </Route>
            <Route path="/kwc-bags">
              <Route index element={<KwcBags />} />
            </Route>
            <Route path="/pick-list">
              <Route index element={<PickList />} />
            </Route>
            <Route path="/qr-codes">
              <Route index element={<QrCodeOverview />} />
            </Route>
            <Route path="/counter-checkout">
              <Route index element={<CounterPickup />} />
            </Route>
            <Route path="/worktable">
              <Route index element={<WorktableList />} />
              <Route path=":worktableId" element={<Worktable />} />
            </Route>
            <Route path="/kwc-bags-test">
              <Route index element={<KwcBagsTest />} />
            </Route>
            <Route path="/kwc-bins-test">
              <Route index element={<KwcBinsTest />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ScannerProvider>
    </AppProvider>
  );
}

export default App;
